<!--
 * @Author: wsx
 * @Date: 2022-02-22 10:48:36
 * @LastEditTime: 2022-02-28 09:43:59
 * @Description: 底部
 * @FilePath: \hz-digital-twin\src\layout\components\MyFooter\index.vue
-->
<template>
  <div class="MyFooter">
    <div class="f-content">
      <div class="f-section left">
        <div class="f-section-content">
          <div class="f-title">人口数量</div>
          <ul class="f-data">
            <li class="f-item" v-for="i in venue" :key="i.id">
              <div class="f-label">
                <i class="f-sign"></i>
                <span>{{ i.name }}</span>
              </div>
              <div class="f-value">{{ i.value }}</div>
            </li>
          </ul>
        </div>
      </div>
      <div class="f-section f-section2 left">
        <div class="f-section-content">
          <div class="f-title">车辆数量</div>
          <ul class="f-data">
            <li class="f-item" v-for="i in manage" :key="i.id">
              <div class="f-label">
                <i class="f-sign"></i>
                <span>{{ i.name }}</span>
              </div>
              <div class="f-value">{{ i.value }}</div>
            </li>
          </ul>
        </div>
      </div>
      <div class="f-centre">
        <div class="f-content-box">
          <div class="f-centre-main">
            <div class="f-centre-main-icon">
              <h-icon icon="icon-shouye" fontSize="28"></h-icon>
            </div>
            <div class="f-centre-main-label">返回主页</div>
          </div>
          <ul class="f-tool-list">
            <template v-for="item in toolList" :key="item.code">
              <li class="f-tool-item">
                <div class="f-tool-icon">
                  <h-icon :icon="item.icon" fontSize="20"></h-icon>
                </div>
                <span>{{ item.name }}</span>
              </li>
            </template>
          </ul>
        </div>
      </div>
      <div class="f-section f-section3 right">
        <div class="f-section-content">
          <div class="f-title">房屋数量</div>
          <div class="f-type">
            <!-- <div>人流量</div>
            <div>车流量</div> -->
          </div>
          <ul class="f-data">
            <li class="f-item" v-for="i in operate" :key="i.id">
              <div class="f-label">
                <i class="f-sign"></i>
                <span>{{ i.name }}</span>
              </div>
              <div class="f-value">{{ i.value }}</div>
            </li>
          </ul>
        </div>
      </div>
      <div class="f-section right alarm">
        <div class="f-section-content">
          <div class="f-title">单位数量</div>
          <ul class="f-data">
            <li class="f-item" v-for="i in alarm" :key="i.id">
              <div class="f-label">
                <i class="f-sign"></i>
                <span>{{ i.name }}</span>
              </div>
              <div class="f-value">{{ i.value }}</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import HIcon from "@/components/global/HIcon.vue";
import { defineComponent, reactive, toRefs } from "vue";
export default defineComponent({
  components: { HIcon },
  name: "MyFooter",
  setup(props) {
    const state = reactive({
      toolList: [
        {
          code: "1",
          name: "人员快搜",
          icon: "icon-sanweiduixiang"
        },
        {
          code: "2",
          name: "落角点分析",
          icon: "icon-cheliang"
        },
        {
          code: "3",
          name: "视图研判",
          icon: "icon-yundanguiji"
        },
        {
          code: "4",
          name: "路径策略",
          icon: "icon-nengyuan"
        },
        {
          code: "5",
          name: "时空碰撞",
          icon: "icon-changguan"
        },
        {
          code: "6",
          name: "涉毒分析",
          icon: "icon-tongjifenxi-xiangmubiaogetongji"
        }
      ],
      venue: [
        {
          id: 1,
          name: "人口总数",
          value: "11000"
        },
        {
          id: 2,
          name: "本地户籍",
          value: "6000"
        },
        {
          id: 3,
          name: "外来人口",
          value: "400"
        },
        {
          id: 4,
          name: "境外来华人员",
          value: "3"
        },
        {
          id: 5,
          name: "未落户人员",
          value: "12"
        },
        {
          id: 6,
          name: "其他",
          value: "12"
        }
      ],
      manage: [
        {
          id: 1,
          name: "登记车辆总数",
          value: "23"
        },
        {
          id: 2,
          name: "本市车辆",
          value: "600"
        },
        {
          id: 3,
          name: "外省市车辆",
          value: "40"
        },
        {
          id: 4,
          name: "使馆车辆",
          value: "89"
        },
        {
          id: 5,
          name: "疑似套牌",
          value: "12"
        },
        {
          id: 6,
          name: "布控车辆",
          value: "12"
        },
        {
          id: 7,
          name: "初次入城",
          value: "12"
        },
        {
          id: 8,
          name: "频繁出没",
          value: "12"
        }
      ],
      alarm: [
        {
          id: 1,
          name: "单位总数",
          value: "203"
        },
        {
          id: 2,
          name: "机关单位",
          value: "600"
        },
        {
          id: 3,
          name: "事业单位",
          value: "40"
        },
        {
          id: 4,
          name: "企业单位",
          value: "89"
        },
        {
          id: 5,
          name: "涉外资单位",
          value: "89"
        },
        {
          id: 4,
          name: "涉港澳台单位",
          value: "89"
        },
        {
          id: 4,
          name: "国有全资单位",
          value: "89"
        },
        {
          id: 4,
          name: "集体全资单位",
          value: "89"
        }
      ],
      operate: [
        {
          id: 1,
          name: "房屋总数",
          value: "456"
        },
        {
          id: 2,
          name: "自用",
          value: "600"
        },
        {
          id: 3,
          name: "租用",
          value: "4"
        },
        {
          id: 4,
          name: "空置",
          value: "3"
        },
        {
          id: 5,
          name: "住宅",
          value: "12"
        },
        {
          id: 6,
          name: "国有房产",
          value: "12"
        },
        {
          id: 7,
          name: "集体所有房产",
          value: "12"
        },
        {
          id: 8,
          name: "私有房产",
          value: "12"
        }
      ]
    });
    const refData = toRefs(state);
    return { ...refData };
  }
});
</script>
<style lang="scss" scoped>
@import "@/assets/utils.scss";
.MyFooter {
  width: 100%;
  height: 280px;
  color: #fff;
  @include flex-row-c-c;
  .f-content {
    height: 100%;
    width: 2840px;
    background-image: url("~@/assets/images/index/footerBg.png");
    background-size: auto 100%;
    background-repeat: no-repeat;
    background-position: center;
    @include flex-row-c-e;
    .f-centre {
      width: 590px;
      height: 100%;
      padding: 50px 0px 35px;
      box-sizing: border-box;
      .f-content-box {
        width: 100%;
        height: 100%;
        position: relative;
        @include flex-row-c-e;
        .f-centre-main {
          position: relative;
          z-index: 2;
          @include flex-col-c-c;
          .f-centre-main-icon {
            height: 80px;
            width: 210px;
            font-size: 28px;
            background-image: url("~@/assets/images/index/footerBtn.png");
            background-size: 100% 100%;
            @include flex-row-c-c;
          }
          .f-centre-main-label {
            font-size: 30px;
            line-height: 36px;
            margin-top: 8px;
            font-family: "YouSheBiaoTiHei";
          }
        }
        .f-tool-list {
          position: absolute;
          top: 0;
          left: 0;
          z-index: 1;
          width: 100%;
          height: 100%;
          .f-tool-item {
            position: absolute;
            font-size: 18px;
            @include flex-col-c-c;
            &:nth-child(1) {
              left: 10%;
              bottom: 5px;
            }
            &:nth-child(2) {
              left: 15%;
              bottom: 50%;
            }
            &:nth-child(3) {
              left: 33%;
              bottom: 70%;
            }
            &:nth-child(4) {
              right: 33%;
              bottom: 70%;
            }
            &:nth-child(5) {
              right: 15%;
              bottom: 50%;
            }
            &:nth-child(6) {
              right: 10%;
              bottom: 5px;
            }
            .f-tool-icon {
              width: 46px;
              height: 46px;
              @include flex-row-c-c;
              border-radius: 50%;
              overflow: hidden;
              position: relative;
              background-color: rgba($color: #000000, $alpha: 0.2);
              z-index: 1;
              margin-bottom: 5px;
              &::after {
                content: "";
                width: 0;
                height: 0;
                box-shadow: 0 0 15px 15px #5b3825;
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                margin: auto;
                z-index: 0;
              }
            }
          }
        }
      }
    }
    .f-section {
      width: 550px;
      height: 220px;
      position: relative;
      &::after {
        content: "";
        height: 100%;
        width: calc(100% + 80px);
        position: absolute;
        top: 0;
        background-image: url("~@/assets/images/index/footerCard.png");
        background-size: 100% 100%;
        z-index: 0;
      }
      &.f-section2,
      &.f-section3 {
        margin-bottom: 20px;
        z-index: 1;
        &::after {
          width: calc(100% + 60px);
        }
      }
      &.right {
        &::after {
          transform: rotateY(180deg);
          right: 0;
        }
        .f-section-content {
          transform: rotateZ(3deg);
          .f-title {
            right: 44px;
          }
        }
      }
      &.left {
        &::after {
          left: 0;
        }
        .f-section-content {
          transform: rotateZ(-3deg);
          .f-title {
            left: 44px;
          }
        }
      }
      .f-section-content {
        position: relative;
        z-index: 1;
        box-sizing: border-box;
        padding: 80px 45px 30px 50px;
        width: 100%;
        height: 100%;
        transform: rotateZ(-5deg);
        .f-title {
          position: absolute;
          top: 14%;
          font-size: 20px;
          width: 103px;
          text-align: center;
          line-height: 34px;
          font-family: "YouSheBiaoTiHei";
        }
        .f-type {
          width: 100%;
          font-weight: 600px;
          font-size: 18px;
          font-family: "YouSheBiaoTiHei";
          @include flex-row-s-c;
          & > div {
            width: 50%;
          }
        }
        .f-data {
          display: grid;
          grid-template-columns: repeat(2, 50%);
          .f-item {
            font-size: 16px;
            font-weight: 100;
            line-height: 30px;
            @include flex-row-s-c;
            &:nth-child(1),
            &:nth-child(2) {
              .f-value {
                color: #8decf4;
              }
            }
            &:nth-child(3),
            &:nth-child(4) {
              .f-value {
                color: #ffb803;
              }
            }
            &:nth-child(5),
            &:nth-child(6) {
              .f-value {
                color: #198afe;
              }
            }
            .f-label {
              margin-right: 10px;
              color: #91c8ff;
              @include flex-row-s-c;
              .f-sign {
                margin-right: 10px;
                display: flex;
                width: 10px;
                height: 10px;
                border-radius: 50%;
                background-color: #be8a63;
                border: 1px solid #cb8847;
                @include flex-row-c-c;
                &::after {
                  content: "";
                  background-color: #fff;
                  width: 2px;
                  height: 2px;
                }
              }
            }
            .f-value {
              font-size: 18px;
              font-family: "YouSheBiaoTiHei";
            }
          }
        }
      }
      &.alarm {
        .f-value {
          color: #ff4176 !important;
        }
      }
    }
  }
}
</style>
